<template>
  <div class="text-center pt-3 pb-3">
    <i class="ti ti-2x ti-fw ti-spin ti-refresh mb-2" />
    <h5>{{ $t(title) }}</h5>
  </div>
</template>

<script>
  export default {
    name: 'LoaderTextComponent',
    props: {
      title: {
        type: String,
        default: '',
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
</style>
